import { UseFormReturn } from 'react-hook-form'
import { z } from 'zod'

import FormSwitch from '@/components/form/formSwitch'

// eslint-disable-next-line react-refresh/only-export-components
export const fixConnectionSchema = z.object({
    createFixConnection: z.boolean(),
})

type FixConnectionSchemaType = z.infer<typeof fixConnectionSchema>

interface Props {
    form: UseFormReturn<FixConnectionSchemaType>
    className?: string | undefined
}

export default function CreateMarketFixConnectionForm({ form, className }: Props) {
    return (
        <FormSwitch
            control={form.control}
            name="createFixConnection"
            label="Create a FIX connection on market creation"
            className={className}
        />
    )
}
